import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const navLinks = [
    { label: '제품소개', id: 'hero' },
    { label: '핵심기술', id: 'solution' },
    { label: '비교', id: 'comparison' },
    { label: '주문하기', id: 'order' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <button onClick={() => scrollTo('hero')} className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/046fff3eb93c7b920ea9980217e91d56/5c83bcb87925a77a3e85b4a671cd71a8.png"
            alt="Smart Cap Logo"
            className="h-14 w-auto object-contain"
          />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? 'text-[#1B2A4A] hover:text-[#FF6B35]'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('order')}
            className="bg-[#FF6B35] text-white text-sm font-semibold px-5 py-2 rounded-md hover:bg-[#E5561F] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            주문하기
          </button>
        </nav>

        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="메뉴"
        >
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? 'bg-[#1B2A4A]' : 'bg-white'} ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? 'bg-[#1B2A4A]' : 'bg-white'} ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? 'bg-[#1B2A4A]' : 'bg-white'} ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="text-sm font-medium text-[#1B2A4A] hover:text-[#FF6B35] text-left cursor-pointer whitespace-nowrap transition-colors"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('order')}
            className="bg-[#FF6B35] text-white text-sm font-semibold px-5 py-2 rounded-md hover:bg-[#E5561F] transition-colors cursor-pointer whitespace-nowrap text-left"
          >
            주문하기
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
